function normalizeSize(value) {
    return typeof value === 'number' && value > 0 ? Math.round(value) : 100;
}
export function parseStateProperties(properties) {
    if (!properties)
        return null;
    try {
        const parsed = JSON.parse(properties);
        if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed))
            return null;
        return parsed;
    }
    catch {
        return null;
    }
}
function baseLayoutFromSceneObject(obj) {
    return {
        left: obj.dropPosition?.left ?? 0,
        top: obj.dropPosition?.top ?? 0,
        width: normalizeSize(obj.width),
        height: normalizeSize(obj.height),
        rotation: 0,
        opacity: 1,
    };
}
function applyParsedToLayout(parsed, cur) {
    if (!parsed)
        return cur;
    return {
        left: parsed.left ?? parsed.x ?? cur.left,
        top: parsed.top ?? parsed.y ?? cur.top,
        width: normalizeSize(parsed.width ?? cur.width),
        height: normalizeSize(parsed.height ?? cur.height),
        rotation: parsed.rotation ?? cur.rotation,
        opacity: parsed.opacity ?? cur.opacity,
    };
}
function firstKeyframeLayoutProps(keyFrames, sceneObjectId) {
    if (!keyFrames?.length)
        return null;
    const sorted = [...keyFrames].sort((a, b) => a.frameNumber - b.frameNumber);
    for (const kf of sorted) {
        const st = kf.objectStates?.find((s) => s.sceneObjectId === sceneObjectId);
        const parsed = parseStateProperties(st?.properties);
        if (parsed)
            return parsed;
    }
    return null;
}
/**
 * Konum/ölçü için kullanılacak property sözlüğü (left/top veya x/y alias'ları ile uyumlu).
 * defaultState yoksa veya bozuksa: sıradaki keyframe state'leri, o da yoksa dropPosition + width/height.
 */
export function resolveSceneObjectLayoutProps(sceneObject, keyFrames) {
    let cur = baseLayoutFromSceneObject(sceneObject);
    const fromDefault = parseStateProperties(sceneObject.defaultState?.properties);
    if (fromDefault) {
        cur = applyParsedToLayout(fromDefault, cur);
    }
    else {
        const fromKf = firstKeyframeLayoutProps(keyFrames ?? undefined, sceneObject.id);
        if (fromKf)
            cur = applyParsedToLayout(fromKf, cur);
        else if (import.meta.env.DEV) {
            console.warn('[sceneObjectLayout] defaultState.properties yok; dropPosition/boyut fallback kullanılıyor', { sceneObjectId: sceneObject.id, name: sceneObject.name });
        }
    }
    const left = Math.round(cur.left);
    const top = Math.round(cur.top);
    return {
        left,
        top,
        x: left,
        y: top,
        width: Math.round(cur.width),
        height: Math.round(cur.height),
        rotation: cur.rotation,
        opacity: cur.opacity,
    };
}
